<template>
  <div class="country-code">
    <div class="modal country-code-modal">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <p class="title">
            {{ $t("language.select-country-code") }}
          </p>
          <div style="margin-bottom: 12px">
            <input
              class="input is-fullwidth is-medium"
              placeholder="Search country or code"
              v-model="searchText"
            />
          </div>

          <!-- <input v-model="phoneNumber" @keyup="messagingApp = null" type="number" /> -->
          <!-- <div style="height: 1200px; overflow: scroll"> -->
          <div style="max-height: calc(100% - 100px); overflow: scroll">
            <table
              v-if="!searchText"
              class="table is-fullwidth is-hoverable"
              style="margin-bottom: 12px"
            >
              <tbody style="border-bottom: 2px; border-radius: 8px">
                <tr
                  v-for="country in popularCountries"
                  :key="country.code"
                  :value="country.code"
                  @click="selectCountry(country)"
                  :class="{ selected: country.prefix == selectedPrefix }"
                  style="border-radius: 8px"
                >
                  <th>{{ country.prefix }}</th>
                  <!-- <th>{{ country.code }}</th> -->
                  <td class="name">{{ country.name }}</td>
                </tr>
              </tbody>
            </table>
            <table class="table is-fullwidth is-hoverable">
              <tbody>
                <tr
                  v-for="country in filteredCountries"
                  :key="country.code"
                  :value="country.code"
                  @click="selectCountry(country)"
                  :class="{ selected: country.prefix == selectedPrefix }"
                >
                  <th>{{ country.prefix }}</th>
                  <!-- <th>{{ country.code }}</th> -->
                  <td class="name">{{ country.name }}</td>
                </tr>
                <tr>
                  <th style="display: flex">
                    <span style="position: relative; top: 3px">+</span>
                    <input
                      class="input"
                      v-model="other"
                      type="number"
                      maxlength="4"
                    />
                  </th>
                  <td class="name" @click="otherCountryCode">
                    {{ $t("other") }}&nbsp;
                    <a
                      v-if="other"
                      class="button is-primary is-small is-rounded"
                    >
                      <i class="fa fa-chevron-right fa-lg" />
                    </a>
                    <p v-if="error && !other" class="has-text-danger error">
                      {{ error }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
    </div>
  </div>
</template>

<script>
import countriesData from "@/data/countries-phone-prefixes.json";

export default {
  name: "CountryCodeModal",
  data() {
    return {
      searchText: null,
      countries: countriesData,
      selectedPrefix: null,
      popularCountries: [
        {
          name: "Thailand",
          prefix: "+66",
          code: "TH",
        },
        {
          name: "United States",
          prefix: "+1",
          code: "US",
        },
        {
          name: "United Kingdom",
          prefix: "+44",
          code: "GB",
        },
        {
          name: "Singapore",
          prefix: "+65",
          code: "SG",
        },
        {
          name: "Japan",
          prefix: "+81",
          code: "JP",
        },
        {
          name: "France",
          prefix: "+33",
          code: "FR",
        },
        {
          name: "Germany",
          prefix: "+49",
          code: "DE",
        },
      ],
      other: "",
      error: null,
    };
  },
  computed: {
    filteredCountries() {
      if (!this.searchText) return this.countries;
      else {
        const query = this.searchText.toLowerCase();
        return this.countries
          .filter((c) => c.name.toLowerCase().includes(query))
          .sort((a, b) => {
            const aName = a.name.toLowerCase();
            const bName = b.name.toLowerCase();

            // Check if starts with query
            const aStarts = aName.startsWith(query);
            const bStarts = bName.startsWith(query);

            if (aStarts && !bStarts) return -1;
            if (!aStarts && bStarts) return 1;

            // Both start with query or neither do - sort alphabetically
            return aName.localeCompare(bName);
          });
      }
    },
  },
  mounted() {},
  methods: {
    closeModal() {
      this.other = "";
      this.error = null;
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    selectCountry(country) {
      this.selectedPrefix = country.prefix;
      // this.$nextTick(() => this.$forceUpdate());
      // this.$nextTick(() => (this.searchText = null));
      // this.searchText = country.name;
      this.console("countryCode", country);
      this.$emit("countryCode", country.prefix);
      setTimeout(() => {
        this.searchText = null;
        this.selectedPrefix = null;
        this.closeModal();
      }, 500);
    },
    otherCountryCode() {
      if (this.other.length === 0) {
        this.error = "Enter a country code";
        return;
      }
      if (this.other.length > 4) {
        this.error = "Invalid country code";
        this.other = "";
        return;
      }
      this.error = null;
      this.console("other countryCode", this.other);
      this.$emit("countryCode", `+${this.other}`);
      setTimeout(() => this.closeModal(), 500);
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  /* border-radius: 25px; */
  padding: 10px;
  max-width: 640px;
}
.title {
  font-size: 1.3em;
  font-weight: 500;
  color: #555;
  margin-bottom: 12px !important;
  margin-top: 6px;
}
.table {
  /* background-color: #eef; */
  background-color: rgb(245, 245, 245);
  border-radius: 3px;
  font-size: 1.2em;
}
.table td,
.table th {
  vertical-align: middle;
  border-bottom: 1px solid white;
}
.table th {
  width: 75px;
  padding-right: 8px;
}
.table tr.selected {
  /*background-color: yellow;
  border: 1px solid yellow;*/
  box-shadow: inset 0px 0px 1px 1px black;
}
.table .flag-icon {
  filter: drop-shadow(1px 1px 3px #777);
  font-size: 1.6em;
  border-radius: 6px;
}
.name {
  text-align: left;
  padding-left: 10px;
}
.unknown-flag {
  filter: drop-shadow(1px 1px 3px #777);
  /* padding: 9px 18px; */
  padding: 5.5px 13px;
  background-color: white;
  border-radius: 6px;
}
.input {
  width: 45px;
  margin-left: 0px;
  display: inline-block;
  font-weight: bold;
}
tr:active {
  transform: scaleY(0.95);
}
.error {
  /* height: 0; */
  /* margin-top: -6px; */
  font-size: 0.8em;
  line-height: 0.8em;
}
</style>
